module.exports = __webpack_public_path__ + "static/media/changjianwentiQ@3x.3b2a44ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/changjianwentiQ@3x.png
// module id = 769
// module chunks = 0